import * as Yup from "yup";

export const createValidationRule = (type, options = {}) => {
  const validationRules = {
    string: (options) =>
      Yup.string()
        .matches(
          /^[A-Za-z\s]+$/,
          options?.message || "Must contain only letters"
        )
        .required("This field is required"),
    number: (options) =>
      Yup.number()
        .positive("Value must be positive")
        .integer("Value must be an integer")
        .transform((value) => (isNaN(value) ? null : value))
        .required(options?.message || "This field is required"),
    phone: (options) =>
      Yup.string()
        .matches(
          /^[1-9]\d{9}$/,
          options?.message || "Please enter a valid 10 digit phone number"
        )
        .required("Phone number is required"),
    email: (options) =>
      Yup.string()
        .email("Invalid email address")
        .required(options?.message || "Email is required"),
    password: (options) =>
      Yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d#@$!%*?&]{8,}$/,
          options?.message ||
            "Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one special character"
        )
        .required("Password is required"),
    confirmPassword: (options) =>
      Yup.string()
        .oneOf(
          [Yup.ref("password"), null],
          options?.message || "Passwords must match"
        )
        .required("Confirm password is required"),
    otp: (options) =>
      Yup.string()
        // .matches(
        //   /^[0-9]{4}$/,
        //   options?.message || "Please enter a valid 4 digit OTP"
        // )
        .required("OTP is required"),
  };

  return validationRules[type](options);
};
